const QUERIES = {
    menu: '.site-menu',
    toggle: '.site-menu-toggle',
    close: null
}

const BREAKPOINT = 1199;

/**
 * This feature is used to set mobile menu behavior
 * 
 * @class Menu
 * @param {Object} [queries]
 * @param {string|number} [breakpoint]
 */

export default class Menu {
    constructor (queries = QUERIES, breakpoint = BREAKPOINT, callback = {}) {
        this.document = document.documentElement;

        const menu = document.querySelector(queries.menu) || document.querySelector(QUERIES.menu);
        if (!menu) throw new Error('Menu not found');

        const toggle = document.querySelector(queries.toggle) || document.querySelector(QUERIES.toggle);
        if (!toggle) throw new Error('Toggle not found');

        const close = queries.close ? document.querySelector(queries.close) : QUERIES.close;

        const controls = menu.querySelectorAll('li > a');
        if (!controls || !controls.length) throw new Error('Controls not found');

        this.menu = menu;
        this.wrapper = menu.parentNode;
        this.toggle = toggle;
        this.close = close;
        this.controls = controls;
        this.breakpoint = breakpoint || BREAKPOINT;
        this.callback = callback;

        this.init();
    }

    init () {
        this.handleToggle();
        this.handleResize();
        this.handleControls();
    }

    handleToggle () {
        if (!this.close) {
            this.toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                const opened = this.menu.classList.contains('opened');

                if (!opened) this.handleOpen();
                if (opened) this.handleClose();
            });
        } else {
            this.toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleOpen();
            });

            this.close.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleClose();
            })
        }
    }

    handleResize () {
        window.addEventListener('resize', (event) => {
            event.stopPropagation();

            if (window.innerWidth > this.breakpoint) this.handleClose();
        });
    }

    handleControls () {
        this.controls.forEach((control) => {
            control.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleClose();
            });
        });
    }

    handleOpen () {
        if (this.document) this.document.classList.add('locked');

        if (this.wrapper) this.wrapper.classList.add('opened');

        this.menu.classList.add('opened');
        this.toggle.classList.add('opened');

        if (this.callback.open) this.callback.open();
    }

    handleClose () {
        if (this.document) this.document.classList.remove('locked');

        if (this.wrapper) this.wrapper.classList.remove('opened');

        this.menu.classList.remove('opened');
        this.toggle.classList.remove('opened');

        if (this.callback.close) this.callback.close();
    }
}

/**
 * Usage example
 * 
 * import Menu from 'components/menu';
 * 
 * const menu = new Menu({
 *  menu: '.site-menu',
 *  toggle: '.site-menu-toggle',
 *  close: '.site-menu-close'
 * });
 * 
 * menu.open();
 * menu.close();
 * 
 */
